import React from 'react';
import { searchnormal } from '../../imagepath';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SearchInput from '../../Forms/SearchInput';
import { Tooltip, Button,Select,Checkbox } from 'antd';
const { Option } = Select;

const ListTableToolbar = ({
  onAdd,
  onSearch,
  onRefresh,
  hideAddAction,
  extra,
  secondaryExtraContent,
  addActionTooltipTitle,
  showApproveFilter = false,
  onshowApproveFilterChange = () => {},
  hasRushstatusFilter = false,
  setHasRushStatusFilter = () => {},
  showHasFilter = false,
  showProStatusFilter = false,
  proStatusOnChange = () => {},
  proStatusFilterValue,
  initialSearchString,
  searchFieldKey = 0,
}) => {
  const handleRefresh = (e) => {
    e?.preventDefault();
    onRefresh?.();
  };

  return (
    <div className="page-table-header mb-2">
      <div className="row align-items-center">
        <div className="col">
          <div className="doctor-table-blk">
            <div className="doctor-search-blk">
              <div className="top-nav-search table-search-blk">
                <form>
                  <SearchInput
                    key={searchFieldKey}
                    className="form-control"
                    onSearchChange={onSearch}
                    initialSearchString={initialSearchString}
                  />
                  <Link className="btn">
                    <img src={searchnormal} alt="#" />
                  </Link>
                </form>
              </div>
              <div className="add-group">
                  {showApproveFilter && (
                    <Select
                      // defaultValue="all"
                      style={{ width: 150, marginRight: 10 }}
                      onChange={onshowApproveFilterChange}
                      className='ms-2'
                      allowClear
                      placeholder="Filter by"
                    >
                      {/* <Option value="all" style={{ display: "none" }}>All</Option> */}
                      <Option value="APPROVED">APPROVED</Option>
                      <Option value="DISAPPROVE">DISAPPROVE</Option>
                      <Option value="DISABLE">DISABLE</Option>
                    </Select>
                  )}
              </div>
              <div className="add-group">
                {showHasFilter && (
                  <Checkbox
                    className="ms-2"
                    checked={hasRushstatusFilter}
                    onChange={(e) => setHasRushStatusFilter(e.target.checked)}
                  >
                    Rush Only
                  </Checkbox>
                )}
              </div>
              <div className="add-group">
                {showProStatusFilter && (
                   <Select
                      value={proStatusFilterValue}
                      style={{ width: 150, marginRight: 10 }}
                      onChange={proStatusOnChange}
                      className='ms-2'
                      allowClear
                      placeholder="Filter by status"
                    >
                      {/* <Option value="all">All</Option> */}
                      <Option value="accepted">Accepted</Option>
                      <Option value="rejected">Rejected</Option>
                      <Option value="submited">Submited</Option>
                      <Option value="assigned">Assigned</Option>
                      <Option value="resolved">Resolved</Option>
                    </Select>
                )}
              </div>
              <div className="add-group">
                {!hideAddAction ? (
                  <Tooltip title={addActionTooltipTitle || 'Add New'}>
                    <Button
                      type="primary"
                      onClick={(e) => {
                        e?.preventDefault();
                        onAdd();
                      }}
                      className="ms-2"
                    >
                      ADD
                      {/* <img src={plusicon} alt="#" /> */}
                    </Button>
                  </Tooltip>
                ) : null}
                <Tooltip title={'Refresh List'}>
                  <Button
                    onClick={handleRefresh}
                    className="ms-2"
                  >
                    Refresh
                  </Button>
                </Tooltip>
                {extra}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mt-3">{secondaryExtraContent}</div>
      </div>
    </div>
  );
};

ListTableToolbar.propTypes = {
  onAdd: PropTypes.func,
  onSearch: PropTypes.func,
  onRefresh: PropTypes.func,
  hideAddAction: PropTypes.bool,
  extra: PropTypes.any,
  secondaryExtraContent: PropTypes.any,
  addActionTooltipTitle: PropTypes.string,
  showApproveFilter: PropTypes.bool,
  onshowApproveFilterChange: PropTypes.func,
  hasRushstatusFilter: PropTypes.bool,
  showHasFilter: PropTypes.bool,
  setHasRushStatusFilter: PropTypes.func,
  showProStatusFilter: PropTypes.bool,
  proStatusOnChange: PropTypes.func,
  proStatusFilterValue: PropTypes.string,
  initialSearchString: PropTypes.string,
  searchFieldKey: PropTypes.number,
};

export default ListTableToolbar;
